<template>
  <div
    @click="selectVenue()"
    style="cursor: pointer"
    class="the-navbar__user-meta flex items-center"
    v-if="activeVenue.name"
  >
    <div class="con-img ml-3">
      <!--
        <img v-if="activeVenue.imageUrl" :src="activeVenue.imageUrl" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      -->
      <img
        src="@/assets/images/venue-image.png"
        alt="user-img"
        width="40"
        height="40"
        class="rounded-full shadow-md cursor-pointer block"
      />
    </div>

    <div class="leading-tight hidden sm:block" style="margin-left: 8px">
      <p class="font-semibold">{{ activeVenue.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    activeVenue() {
      return {
        id: localStorage.getItem("activeVenue"),
        name: localStorage.getItem("rekom.life.venueName"),
        imageUrl: localStorage.getItem("rekom.life.venueImageUrl"),
      };
    },
  },
  methods: {
    selectVenue() {
      this.$router.push({ name: "select-venue" }).catch(() => {});
    },
    logout() {
      this.$router.push("/auth/login").catch(() => {});
    },
  },
};
</script>
